export default "__VITE_ASSET__D8Oqu8JA__"